export default __webpack_public_path__ + "static/media/img_mer_no_image.72db7d67.svg";